import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller, useFieldArray } from 'react-hook-form';
import Input from '../../../../components/elements/form/input';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import { AgGridReact } from 'ag-grid-react';
import { useAppLoader } from '../../../../_common/pageLoader/appLoaderHook';
import { useStockAdjustmentApi } from '../../../../store/api/hooks/stockAdjustmentApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
import { getSelectedOption, showDate, showLocalDateTime } from '../../../../_common/functions';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../../_common/constant';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import { useCycleCountApi } from '../../../../store/api/hooks/cycleCountApiHook';
import Label from '../../../../components/elements/form/fromLabel';
import Currency from '../../../../components/currency';


interface StockAdjFormProps {
    data?: any;
    onCancel?: () => void
    partDetails?: any
}
type partType = {
    id?: number;
    partDetails?: any;
    partCode?: string;
    partName?: string;
    stockOnHand?: number;
    adjustedQuantity?:any;
    qty?: any;
    cost?: number;
    part?:any
}

type FormValues = {
    stockAdjustmentID?: number;
    stockAdjustmentSerialNo: string;
    stockAdjustmentDate: string;
    operatorID: any;
    facilityID: any;
    subFacilityID: any;
    stockAdjustmentNote: string;
    adjustmentDetailsList: any[];
    parts: partType[];
};

const ViewStockAdjustment: React.FC<StockAdjFormProps> = ({data, onCancel = () => { } , partDetails}) => {
    const { control, register, handleSubmit, formState: { errors }, reset , setValue, watch} = useForm<FormValues>();
    const stockAPI = useStockAdjustmentApi();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const assetApi: any = useAssetsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const [facilityoption, setFacilityoption] = useState<any>(null);
    const [subFacilityOptions, setSubFacilityOptions] = useState<any>([]);
    const [vendorlist, setvendorList] = useState<any>([]);
    const [editData, setEditData] = useState<any>(null);
    const [disabledFacility, setDisabledFacility] = useState<boolean>(false);
    const cycleCountAPI = useCycleCountApi();
    const user:any = useUserSelector();

    const facilityWatch = watch('facilityID');

    

    const { fields: parts, append, update, prepend, remove, swap, move, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "parts", // unique name for your Field Array
    });

    const partsWatch:any = watch('parts');


    const getNewCode = () => {
        stockAPI.getStockAdjustmentCode({},
            (resp: any) => {
                console.log("New Code", resp)
            }, (error: any) => {
                console.log("New Code Error", error)
            }
        )
    }
    

    const getfacilitylist = () => {
        const payload = {
            pageSize: 100,
            pageNumber: 1,
        };
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = resp.facilityList.map((facilist: any) => {
                    return {
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                    };
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const getVenderList = () => {
        const payload = {};
        assetApi.GetvenderList(
            payload,
            (resp: any) => {
                let deptlist: any = resp.vendorList.map((facilist: any) => {
                    return {
                        label: facilist.name,
                        value: facilist.vendorID,
                    }
                });
                setvendorList(deptlist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };
   

   

    const formReset = () => {
        if (!partDetails) {
            reset({
                stockAdjustmentSerialNo: "",
                stockAdjustmentDate: "",
                operatorID: "",
                facilityID: "",
                stockAdjustmentNote: "",
                adjustmentDetailsList: [],
            });
            remove();
            setDisabledFacility(false);
        }

    }

    useEffect(() => {
        if (facilityWatch) {
            setValue('subFacilityID', null);
            const payload = {
                facilityID: facilityWatch.value
            }
            facilityApi.getSubFacilityList(
                payload,
                (resp: any) => {
                    setSubFacilityOptions(resp?.subFacilityList?.map((facilist: any) => {
                        return {
                            label: `${facilist.subFacilityTypeName} - ${facilist.no}`,
                            value: facilist.subFacilityID,
                        };
                    }));
                },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    }, [facilityWatch]);

    useEffect(() => {
        //getNewCode();
        getfacilitylist();
        getVenderList();
    }, []);

    useEffect(() => {
        console.log("list data ---->", data)
        if (data.partsStockAdjustmentID) {
            stockAPI.getStockAdjustmentByID({ PartsStockAdjustmentID: data.partsStockAdjustmentID }, (resp: any) => {
                console.log("fetch  Data ---- ", resp)
                setEditData(resp);
            }, (error: any) => {
                console.log("Edit Data Error", error)
            })
        }
    }, [data]);

    useEffect(() => {
        console.log("Parts Watch", partsWatch)
    }, [partsWatch]);

    useEffect(() => {
        console.log(editData);
        if (editData == null) {
            formReset();
        }
    }, [editData]);

    useEffect(() => {
        if (editData) {
           // console.log("sfsfsdfsfsd",editData);
            reset({

                stockAdjustmentSerialNo: editData.stockAdjustmentSerialNo,
                stockAdjustmentDate: showDate(editData.stockAdjustmentDate, DATE_FORMAT),
                operatorID: getSelectedOption(editData.operatorID, vendorlist),
                facilityID: getSelectedOption(editData.facilityID, facilityoption? facilityoption : []),
                subFacilityID: getSelectedOption(editData.subFacilityID, subFacilityOptions),
                stockAdjustmentNote: editData.stockAdjustmentNote,
                parts: editData?.stockAdjustmentList.map((part: any) => {
                    return {
                        partCode: part.partsCode,
                        partName: part.partName,
                        stockOnHand: part.stockOnHand,
                        qty: part.stockOnHand,
                        adjustedQuantity:  part.adjustedQuantity,
                        cost: part.partsTotalAmount,
                        partDetails: { ...part, sparePartsName: part.partName, currenctStock: part.stockOnHand, costPerUnit: part.partsCostRate, }
                    }
                }
                )
            });
        }
    }, [editData, facilityoption, vendorlist]);

    useEffect(() => {
        if (partDetails && facilityoption) {
            console.log('~~~~~~~~~~~~',facilityoption, getSelectedOption(partDetails.facilityID, facilityoption? facilityoption : []))
            reset({
                facilityID: getSelectedOption(partDetails.facilityID, facilityoption? facilityoption : []),
                //subFacilityID: getSelectedOption(editData.subFacilityID, subFacilityOptions),
                stockAdjustmentNote: '',
                parts: []
            });
            remove();
            cycleCountAPI.GetStockCount({partID: partDetails.partsID,facilityID: partDetails.facilityID},(resp: any) => {
                console.log("stock response",resp);
                append({
                    partCode: partDetails.partsCode,
                    partName: partDetails.partName,
                    stockOnHand: resp.currentStock || 0,
                    adjustedQuantity:0,
                    qty: resp.currentStock || 0,
                    cost: (resp.currentStock || 0) * partDetails.costPerUnit,
                    part: partDetails,
                    partDetails: partDetails
                })
            },
            (error: any) => {
              
            }
        );
        }
    }, [partDetails, facilityoption]);

 



    return (
        <form >
            <div className='pt-4'>
                {
                    editData && <>
                        <div className="grid grid-cols-3 gap-2">
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Adjustment No</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.stockAdjustmentSerialNo}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3 '>
                                <h6 className='text-[0.813rem] font-semibold'>Adjusted By</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{data?.addedByName}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Date and Time</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{showLocalDateTime(editData?.stockAdjustmentDate)}</p>
                            </div>
                        </div>
                    </>
                }

                {/* <div className="grid grid-cols-2 gap-2"> */}
                <div className="grid grid-cols-3 gap-2 py-4">
                <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Facility name</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.facilityName}</p>
                            </div>
                            <div className='bg-green-50 py-2 px-3'>
                                <h6 className='text-[0.813rem] font-semibold'>Sub Facility name</h6>
                                <p className='text-[0.813rem] font-normal mt-2'>{editData?.subFacilityName}</p>
                            </div>

                </div>
              
                   

                <div className='rounded-md border border-gray-300'>
                    <div className='grid grid-cols-12 gap-1 bg-gray-100'>
                        <div className='col-span-3 px-2 leading-10 '>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Part Code</label>
                        </div>
                        <div className='col-span-3 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Part Name</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Stock on Hand</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Adjusted Qty</label>
                        </div>
                        <div className='col-span-2 px-2 leading-10'>
                            <label className='text-[0.75rem] font-medium text-slate-600'>Adjusted Cost</label>
                        </div>
                    </div>
                    {parts.map((part, index) => (
                        <div className='grid grid-cols-12 gap-1 text-slate-800' key={part.id}>
                            <div className='col-span-3 px-2 leading-10 flex items-center'>
                            <p className='font-medium text-[0.75rem]'>{part.partCode}</p>
                               
                            </div>
                            <div className='col-span-3 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal leading-[1.2]'>{part?.partDetails?.sparePartsName}</label>
                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal text-center w-full'>{part?.stockOnHand}</label>
                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                {part?.adjustedQuantity  ?
                                   
                                   part?.adjustedQuantity
                                    : <p className='text-center w-full'>-</p>
                                
                                }

                            </div>
                            <div className='col-span-2 px-2 leading-10 flex items-center'>
                                <label className='text-[0.75rem] font-normal text-center w-full'>
                                    {part?.cost? (<Currency currency="USD" value={part?.cost}></Currency>) : '-'}</label>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='mt-2'>
                    <Label text='Note' required={false} />
                    <p className='text-[0.75rem] italic font-normal mt-1'>{editData?.stockAdjustmentNote}</p>
                </div>
                

                <hr className='border-gray-900 my-6' />
            </div>
            <div className='flex justify-end gap-2'>
                
                <Button theme='secondary' onClick={()=>{
                    onCancel();
                }}>Close</Button>
            </div>

            
        </form>
    );
};

export default ViewStockAdjustment;